import { SelectedProductInterface } from 'domains/Catalog/Products/components';
import { ExceptionProductsType, SimpleProductType } from './types';

export const convertToSelectedProduct = (
  product: SimpleProductType,
): SelectedProductInterface => ({
  id: product.id,
  name: product.name,
  imageUrl: product.imageUrl,
  stock: false,
  visible: true,
  attributes: [],
  variants: [],
});

export const initialValues = {
  name: '',
  taxRate: null,
  products: [] as SimpleProductType[],
};

export const exceptionsWithoutGeneral = (
  exceptionsTaxRules: ExceptionProductsType[],
) =>
  exceptionsTaxRules
    ? exceptionsTaxRules
        .filter((item) => !item.is_general)
        .map(
          (item): ExceptionProductsType => ({
            id: item.id,
            description: item.description,
            is_general: item.is_general,
            iva_rate: item.iva_rate,
            products: item.products,
          }),
        )
    : [];
